import { render, staticRenderFns } from "./photoOverlay.vue?vue&type=template&id=4e6ffe97&scoped=true"
import script from "./photoOverlay.vue?vue&type=script&lang=js"
export * from "./photoOverlay.vue?vue&type=script&lang=js"
import style0 from "./photoOverlay.vue?vue&type=style&index=0&id=4e6ffe97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ffe97",
  null
  
)

export default component.exports